import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import posed from "react-pose";
import { Motion, spring } from "react-motion";
import { colors } from "../../theme";
import ShareButtons from "../../components/ShareButtons";
import { sortBy } from "lodash";

const LinkBox = styled(
  posed.div({
    normal: {
      color: "#ffffff",
      backgroundColor: "rgba(0,0,0,0)"
    },
    selected: {
      color: colors.darkBlue,
      backgroundColor: colors.yellow
    }
  })
)`
  display: inline-block;
  border-radius: 5px;
  border: 3px solid #fff200;
  padding: 5px;
  font-size: 12px;
  z-index: 5;
  margin-right: 10px;
  text-decoration: none;
  font-weight: bold;

  @media (min-width: 575px) {
    padding: 10px;
    font-size: 14px;
  }
`;

const ColorDot = styled.div`
  display: inline-block;
  margin-right: 5px;
  width: 8px;
  height: 8px;
  background-color: ${props => (props.color ? props.color : "#CCC")};
  border-radius: 10px;
`;

const StyledLink = styled(Link)`
  color: ${props => (props.selected ? colors.darkBlue : "white")};
  text-decoration: none;
`;

class ScrollView extends PureComponent {
  div = null;

  componentDidUpdate(prevProps) {
    if (prevProps.scrollLeft !== this.props.scrollLeft) {
      this.div.scrollLeft = Math.round(this.props.scrollLeft.scrollLeft);
    }
  }

  render() {
    return (
      <div
        ref={r => {
          this.div = r;
        }}
        className={this.props.className}
      >
        {this.props.children}
      </div>
    );
  }
}

const OuterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.darkGreen};
`;

const PartyFilterWrapper = styled(ScrollView)`
  padding: 5px;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-scrolling: touch;
  -webkit-overflow-scrolling: touch;

  @media (min-width: 575px) {
    padding: 10px;
    overflow-x: auto;
    overflow-scrolling: auto;
  }

  @media (min-width: 769px) {
    overflow-x: auto;
    overflow-scrolling: auto;
  }
`;

const Scrollable = styled.div`
  display: inline-block;
`;

class PartyFilter extends PureComponent {
  scrollable = null;
  state = {
    scrollLeft: 0
  };

  componentDidMount() {
    if (this.scrollable.offsetWidth > window.innerWidth) {
      setTimeout(() => {
        this.setState({ scrollLeft: 20 });
      }, 300);
    }
  }

  render() {
    const { parties, citySlug, partySlug, city } = this.props;
    const { scrollLeft } = this.state;

    return (
      <OuterWrapper>
        <Motion
          defaultStyle={{ scrollLeft: 0 }}
          style={{ scrollLeft: spring(scrollLeft) }}
          onRest={() => setTimeout(() => this.setState({ scrollLeft: 0 }), 5)}
        >
          {scrollLeft => (
            <PartyFilterWrapper scrollLeft={scrollLeft}>
              <Scrollable
                innerRef={r => {
                  this.scrollable = r;
                }}
              >
                <LinkBox key={"all"} pose={!partySlug ? "selected" : "normal"}>
                  <StyledLink
                    to={`/gemeente/${citySlug}`}
                    selected={!partySlug}
                  >
                    Alle partijen
                  </StyledLink>
                </LinkBox>
                {sortBy(parties, [o => o.name.toLowerCase()]).map(party => (
                  <LinkBox
                    key={party.id}
                    pose={partySlug === party.slug ? "selected" : "normal"}
                  >
                    <StyledLink
                      to={`/gemeente/${citySlug}/${party.slug}`}
                      selected={partySlug === party.slug}
                    >
                      <ColorDot color={party.color} />
                      {party.name}
                    </StyledLink>
                  </LinkBox>
                ))}
              </Scrollable>
            </PartyFilterWrapper>
          )}
        </Motion>
        {!partySlug && <ShareButtons mode="city" small={true} city={city} />}
      </OuterWrapper>
    );
  }
}

export default PartyFilter;



// WEBPACK FOOTER //
// ./src/pages/City/PartyFilter.js